import { useCallback, useRef } from 'react';
import { useRoutesContext } from '../index';

import { Routes, Route } from 'common/utils/Route/types/routes';

export const useHideRoutes = () => {
  const { routes } = useRoutesContext();
  const routeRef = useRef<Routes>();

  routeRef.current = routes;

  const hideRoutes = useCallback((plannedRoutes?: Route[]) => {
    (plannedRoutes || routeRef.current || []).forEach((route) => {
      route.delete();
    });
  }, [routeRef]);

  return hideRoutes;
};

